<template>
  <div class="sidebar">
    <el-menu class="sidebar-el-menu" :default-active="$route.path" :collapse="collapse" background-color="#324157"
      text-color="#bfcbd9" active-text-color="#20a0ff" @select="handleSelect" unique-opened router>
      <template v-for="(item, index) in items" :key="index">
        <el-submenu :index="item.ID + '/'" v-if="item.children.length>0 && item.parentId === 0">
          <template #title>
            <i :class="item.icon"></i>
            <span>{{ item.name }}</span>
          </template>
          <el-menu-item v-for="(subItem,idx) in item.children" :index="subItem.path" :key="idx">
            <template #title>
              <i :class="subItem.icon"></i>
              <span>{{ subItem.name }}</span>
            </template>
          </el-menu-item>
        </el-submenu>
        <el-menu-item :index="item.path?item.path:(item.parentId+item.ID)" v-else>
          <i :class="item.icon"></i>
          <template #title>{{ item.name }}</template>
        </el-menu-item>
      </template>
    </el-menu>
  </div>
</template>

<script>

import { getMyMenu } from "@/api/login"

export default {
  data() {
    return {
      items: [],
      isCollapse: true
    };
  },
  created() {
    this.getMenuList()
  },
  computed: {
    // onRoutes() {
    //   return this.$route.path.replace("/", "");
    // },
    collapse() {
      return this.$store.state.collapse
    }
  },
  methods: {
    getMenuList() {
      getMyMenu().then(res => {
        if (res.code == 0) {
          this.items = res.data
        }
      })
    },
    handleSelect(){
      // console.log(key,keyPath)
      // this.$store.dispatch('setTagsItem', keyPath)
    }
  }
};
</script>

<style scoped>
.sidebar {
  display: block;
  position: absolute;
  left: 0;
  top: 70px;
  bottom: 0;
  overflow-y: scroll;
}

.sidebar::-webkit-scrollbar {
  width: 0;
}

.sidebar-el-menu:not(.el-menu--collapse) {
  width: 150px;
}

.sidebar>ul {
  height: 100%;
}
</style>
